import { createContext, useContext, useMemo, useState, FC, ReactNode } from "react";
import { VersionT } from "../../models/models";

export function getMarkNotSuitableFormDirty(
  data: VersionT,
  initial: VersionT
): boolean {
  const normType = (v: VersionT) =>
    v.NotSuitableForBroadcastType !== undefined
      ? v.NotSuitableForBroadcastType
      : 1;
  return (
    data.NotSuitableForBroadcast !== initial.NotSuitableForBroadcast ||
    data.NotSuitableForBroadcastReason !== initial.NotSuitableForBroadcastReason ||
    normType(data) !== normType(initial) ||
    (data.NotSuitableForBroadcastComment || "") !==
      (initial.NotSuitableForBroadcastComment || "")
  );
}

type MarkNotSuitableFormDirtyContextValue = {
  isDirty: boolean;
  setFormDirty: (dirty: boolean) => void;
};

const MarkNotSuitableFormDirtyContext =
  createContext<MarkNotSuitableFormDirtyContextValue | null>(null);

export const MarkNotSuitableFormDirtyProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isDirty, setFormDirty] = useState(false);
  const value = useMemo(
    () => ({ isDirty, setFormDirty }),
    [isDirty]
  );
  return (
    <MarkNotSuitableFormDirtyContext.Provider value={value}>
      {children}
    </MarkNotSuitableFormDirtyContext.Provider>
  );
};

export function useMarkNotSuitableFormDirtyState(): MarkNotSuitableFormDirtyContextValue {
  const ctx = useContext(MarkNotSuitableFormDirtyContext);
  if (!ctx) {
    throw new Error(
      "useMarkNotSuitableFormDirtyState must be used within MarkNotSuitableFormDirtyProvider"
    );
  }
  return ctx;
}
